export const G_ANALYTICS_TAG = 'G-TEDBTZ176T';

const createAnalyticsScript = () => {
    window.dataLayer = window.dataLayer || [];
    window.gtag = function () {
        window.dataLayer.push(arguments);
    };

    window.gtag('consent', 'default', {
        analytics_storage: 'denied',
        ad_storage: 'denied',
        ad_user_data: 'denied',
        ad_personalization: 'denied',
    });

    let script = document.createElement('script');
    script.src = `https://www.googletagmanager.com/gtag/js?id=${G_ANALYTICS_TAG}`;
    script.async = true;
    document.head.appendChild(script);
    window.gtag('js', new Date());
};

const changeGtagConsent = (c) => {
    const value = c ? 'granted' : 'denied';
    window.gtag('consent', 'update', {
        analytics_storage: value,
        ad_storage: value,
        ad_user_data: value,
        ad_personalization: value,
    });
    window.gtag('config', G_ANALYTICS_TAG, {
        update_view_id: true,
    });
};

export const allowGoogleAnalytics = (accept) => {
    const loaded = typeof window.gtag === 'function';
    if (accept) {
        if (!loaded) createAnalyticsScript();
        changeGtagConsent(true);
    } else {
        if (loaded) changeGtagConsent(false);
    }
};
